import React, { ReactElement } from 'react';
import { NavLink } from 'react-bootstrap';
import { Box, styled, themeGet } from '@qwealth/qcore';
import InfoTag from '../InfoTag';
import { SectionHeaderDetailColumnContent } from '../SectionHeaderDetailColumn';
import { useNavigate } from 'react-router';

export const StyledSectionHeaderLink = styled(NavLink)`
  display: flex;
  flex-direction: row;
  color: ${themeGet('colors.dark')};
  font-size: ${themeGet('fontSizes.large')};
  font-weight: ${themeGet('fontWeights.thin')};
  align-items: center;
  width: fit-content;
  gap: default;
  cursor: pointer;

  &:hover {
    color: ${themeGet('colors.primary')};
  }
`;

interface ContentLinkProps {
  contents: SectionHeaderDetailColumnContent[];
  icon: JSX.Element;
  hasKYCTimer?: boolean;
}

const ContentLinks: React.FC<ContentLinkProps> = ({ contents, icon, hasKYCTimer }): ReactElement => {
  const navigate = useNavigate();

  const checkShouldDisplayKycTimer = (content: SectionHeaderDetailColumnContent) => {
    return (
      content !== undefined &&
      hasKYCTimer &&
      content.kycDaysRemaining !== undefined &&
      content.kycLink !== undefined &&
      !Number.isNaN(content.kycDaysRemaining)
    );
  };

  return (
    <>
      {contents.map((content, index) => {
        const shouldDisplayKycTimer = checkShouldDisplayKycTimer(content);
        return content ? (
          <React.Fragment key={`${content.label}-${index}`}>
            <StyledSectionHeaderLink onClick={() => navigate(content.link)}>
              {icon}
              <Box as="span" marginRight="small" marginLeft="small">
                {content.label}
              </Box>
              {content.infoTag}
            </StyledSectionHeaderLink>
            {shouldDisplayKycTimer && (
              <StyledSectionHeaderLink onClick={() => navigate(content.kycLink ? content.kycLink : '')} border="none" backgroundColor="white">
                <InfoTag
                  tagTitle={content.kycDaysRemaining && content.kycDaysRemaining <= 0 ? 'KYC Warning' : 'KYC Reminder'}
                  numberToDisplay={content.kycDaysRemaining}
                />
              </StyledSectionHeaderLink>
            )}
          </React.Fragment>
        ) : (
          <Box as="span" key={`na-${index}`}>
            N/A
          </Box>
        );
      })}
    </>
  );
};

export default ContentLinks;
